<template>
  <div class="fixed z-10 flex justify-end w-full tracking-normal normal-case">
    <div @click.prevent="show" class="p-2 m-2 border border-white rounded-full bg-live-orange hover:bg-live-blue">
      <Zondicon icon="user" class="inline-block w-6 h-6 p-1 text-gray-300 cursor-pointer fill-current hover:text-gray-200"/>
    </div>
    
    <modal name="modal-login" @opened="opened" :adaptive="true" :height="400" :width="400">
      <div class="px-10 py-8">
        <h2 class="mb-4 text-xl tracking-wide">{{ $t('nav.login') }}</h2>
        <form @submit.prevent="loginUser">
          <div class="mb-4 form-group">
            <label for="email" class="block mb-1 text-xs font-normal tracking-wide uppercase">{{ $t('modal.email') }}</label>
            <input v-model="email" type="email" id="email" name="email" class="w-full px-4 py-2 bg-gray-200 border rounded" ref="email" @keydown.shift.tab.prevent="">
          </div>
          <div class="mb-8 form-group">
            <label for="password" class="block mb-1 text-xs font-normal tracking-wide uppercase">{{ $t('modal.password') }}</label>
            <input v-model="password" type="password" id="password" name="password" class="w-full px-4 py-2 bg-gray-200 border rounded">
          </div>
          <!-- <div class="mb-8 form-group">
            <label class="text-sm font-normal"><input type="checkbox" name="remember" class="mr-2">Keep me signed in</label>
          </div> -->
          <div class="mb-4 form-group">
            <button type="submit" class="w-full px-4 py-2 text-white rounded bg-live-orange hover:bg-live-blue">{{ $t('nav.login') }}</button>
          </div>
          <div v-if="error" class="py-2 text-sm font-normal text-center text-red-600">{{ error.message }}</div>
        </form>
        <div class="text-sm font-normal text-center">
          <p>{{ $t('modal.msgRegister') }} <a href="#" class="text-blue-600 hover:text-blue-800" @click.prevent="showRegister" @keydown.tab.exact.prevent="">{{ $t('nav.register') }}</a></p>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
// Firebase
import * as firebase from "firebase/app";
import "firebase/auth";

export default {
  data() {
    return {
      email: "",
      password: "",
      error: ""
    };
  },
  methods: {
    show() {
      this.$modal.show("modal-login")
    },
    showRegister() {
      this.$modal.show("modal-register")
      this.$modal.hide("modal-login")
    },
    opened() {
      this.$refs.email.focus()
    },
    hide() {
      this.$modal.hide("modal-login")
    },
    async loginUser(){
        try {
            await firebase.auth().signInWithEmailAndPassword(this.email, this.password);
            this.$modal.hide("modal-login")
            this.$router.replace({ name: 'Dashboard' });
        } catch (error) {
          this.error = error;
          console.log(error);
        }
    }
  }
}
</script>